import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(BarElement, Tooltip, Legend); // Ensure BarElement, Tooltip, and Legend are registered

const BarChart = ({ forecastedCost, totalPotentialSavings, smallVersion }) => {
  // Calculate the remaining cost
  const remainingCost = forecastedCost - totalPotentialSavings;

  const data = {
    labels: ['Cost Breakdown'], // Single label for the bar
    datasets: [
      {
        label: 'Potential Cost Savings',
        data: [totalPotentialSavings], // Data for the potential savings
        backgroundColor: '#57b960', // Green color
        borderColor: '#388e3c', // Green border
        borderWidth: 1, // Border width for the bar
        stack: 'stack1', // Ensure stacking
      },
      {
        label: 'Cost after Optimization',
        data: [remainingCost], // Data for the remaining cost
        backgroundColor: '#ffa500', // Orange color
        borderColor: '#ff8c00', // Orange border
        borderWidth: 1, // Border width for the bar
        stack: 'stack1', // Ensure stacking
      }
    ],
  };

  const options = {
    maintainAspectRatio: false,
    indexAxis: 'y', // Display bar chart horizontally
    scales: {
      x: {
        stacked: true, // Stack bars on the x-axis
        beginAtZero: true,
        grid: {
          display: false, // Hide x-axis grid lines
        },
        ticks: {
          display: false, // Hide x-axis labels
        },
      },
      y: {
        display: false, // Hide y-axis
      },
    },
    plugins: {
      legend: {
        display: false, // Hide legend
      },
      tooltip: {
        enabled: true, // Disable tooltips
      },
    },
  };

  // Set the height of the chart based on the `smallVersion` prop
  const chartHeight = smallVersion ? '40px' : '100px';

  return (
    <div style={{ height: chartHeight, width: '100%' }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default BarChart;
